module.exports = __webpack_public_path__ + "img/tool-triangle-right.2739cfdb.svg";